import _ from 'lodash';

import sourceFields from '../../constants/sourcesFields';

const state = {
  allSourceFields: null,
};

const getters = {
  sortedBankSources: state => {
    const bankArray = _.filter(state.allSourceFields, source => source.type === 'bank' && !source.hidden);
    return _.sortBy(bankArray, b => b.sortPriority);
  },
};

const actions = {
  async initSourceFields({ commit }) {
    if (!state.allSourceFields) {
      commit('setSourceFields', sourceFields.allSourceFields);
    }
  },
};

const mutations = {
  setSourceFields(state, sourceFields) {
    state.allSourceFields = sourceFields;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
